export enum FeatureFlag {
  ExperimentalUI = 'EXPERIMENTAL_UI',
}
